import { Stack } from "@mui/system";
import {
  Autocomplete,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import PageGroupFilter from "../PageGroupFilter/PageGroupFilter";
import CreateNewRequestModal from "../PageGroupModal/CreateNewRequestModal";
import { useEffect, useState } from "react";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import store from "../../../../../store";
import { setSelectedPageGroup } from "../../../../../features/pageGroupSlice";

interface PageGroupFilterCardProps {
  setSelectedAbTest: any;
  selectedAbTest: any;
  setSelectedPopup: any;
  selectedPopup: any;
  setSelectedTheme: any;
  selectedTheme: any;
  pageGroups: any;
  setSelectedPageGroup: any;
  selectedPageGroup: any;
  selectedSiteUid: any;
  setTableRefresh: any;
}

function PageGroupFilterCard({
  selectedSiteUid,
  setTableRefresh,
}: PageGroupFilterCardProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pageGroupData, selectedPageGroup } = useSelector(
    (state: any) => state.pageGroup,
  );
  const uniquePageGropuNames = Array.from(
    new Set(pageGroupData.map((group: any) => group.group_name)),
  );

  const [openModal, setopenModal] = useState(false);
  const response = useSelector(selectUserData);
  const hasCreatePageGroupPermission = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "create_page_groups",
  );

  const handleOpenModal = () => {
    setopenModal(true);
  };

  const handleCloseModal = () => {
    setopenModal(false);
  };
  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    store.dispatch(setSelectedPageGroup(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Typography fontSize={24}>Page Group List</Typography>
      <Typography sx={{ color: "#00000099", paddingBottom: "16px" }}>
        Edit a page group or create a new one.
      </Typography>
      <Stack flexDirection={"row"} justifyContent={"start"} gap={2}>
        <Autocomplete
          data-tracker="31"
          sx={{ width: "300px" }}
          options={uniquePageGropuNames ? uniquePageGropuNames : []}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Page Group Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
          onChange={(_, newValue: any) => {
            store.dispatch(setSelectedPageGroup(newValue));

            // Preserve existing search params while updating 'selectedTemplate'
            setSearchParams((prevParams) => {
              const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
              if (newValue) {
                updatedParams.search = newValue; // Set new value
              } else {
                delete updatedParams.search; // Remove from URL if cleared
              }
              return updatedParams;
            });
          }}
          value={selectedPageGroup}
        />
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <PageGroupFilter />
          {hasCreatePageGroupPermission ? (
            <Button
              data-tracker="37"
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              onClick={handleOpenModal}
            >
              New Group <AddIcon />
            </Button>
          ) : (
            <Button
              disabled
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
            >
              New Group <AddIcon />
            </Button>
          )}
        </Stack>
        <CreateNewRequestModal
          open={openModal}
          handleClose={handleCloseModal}
          selectedSiteUid={selectedSiteUid}
          setTableRefresh={setTableRefresh}
        />
      </Stack>
    </>
  );
}

export default PageGroupFilterCard;
